import type { JSX } from "react";

import { Dialog as BaseDialog } from "@base-ui/react/dialog";

import { useDialogAnimationContext } from "./Dialog.context";
import type { DialogTriggerProps } from "./Dialog.types";

export function DialogTrigger({
  onPointerDown,
  ...props
}: DialogTriggerProps): JSX.Element {
  const originRef = useDialogAnimationContext();

  return (
    <BaseDialog.Trigger
      data-slot="dialog-trigger"
      onPointerDown={(event) => {
        const target = event.currentTarget;

        const el =
          getComputedStyle(target).display === "contents"
            ? (target.firstElementChild ?? target)
            : target;

        originRef.current = el.getBoundingClientRect();
        onPointerDown?.(event);
      }}
      {...props}
    />
  );
}
